import { useMutation, useQuery } from '@tanstack/react-query'
import {
  createBooking,
  getHoursAvailable,
  reportBookingCapacity,
  getPayOrder,
  apiPayment,
  getPayMethods,

} from '../services/Services'
import { geAreasDataTypes } from '../types/Services'
import { uploadProof as uploadProofService } from '../services/Services'
import { queryClient } from './config'

export const useHoursAvailable = (date: any, iDCompany: geAreasDataTypes) => {
  return useQuery({
    queryKey: ['hoursAvailable', date, iDCompany?.body?.id],
    queryFn: () => getHoursAvailable(date, iDCompany),
    enabled: !!date && !!iDCompany?.body?.id
  })
}

export const useBookingCapacity = (
  companyId: number,
  date: string,
  areaId: number,
  areaDetailId?: number
) => {
  return useQuery({
    queryKey: ['bookingCapacity', companyId, date, areaId, areaDetailId],
    queryFn: () => reportBookingCapacity(companyId, date, areaId, areaDetailId),
    enabled: !!companyId && !!date && !!areaId
  })
}

export const useCreateBooking = () => {
  return useMutation({
    mutationFn: ({ data, companyId }: { data: any; companyId: any }) =>
      createBooking(data, companyId),
    onSuccess: () => {
      // Invalidar queries relacionadas
      queryClient.invalidateQueries({ queryKey: ['hoursAvailable'] })
      queryClient.invalidateQueries({ queryKey: ['bookingCapacity'] })
    }
  })
}

export const usePayOrder = () => {
  return useMutation({
    mutationFn: (data: any) => getPayOrder(data)
  })
}

export const usePayment = () => {
  return useMutation({
    mutationFn: ({ accessToken, data }: { accessToken: string; data: any }) =>
      apiPayment(accessToken, data)
  })
}

export const usePayMethods = (companyId: number) => {
  return useQuery({
    queryKey: ['payMethods', companyId],
    queryFn: () => getPayMethods(companyId),
    enabled: !!companyId
  })
}

export const useUploadProof = () => {
  console.log('useUploadProof');

  return useMutation({
    mutationFn: (data: any) => uploadProofService(data)
  })
}
